<template>
	<div class="more_menu_header-mobile">
		<button class="btn_back" @click="onClickResetHeaderMenu">
			<img src="@/assets/img/common/arrow_prev.svg" alt="close" loading="lazy" />
			<span v-if="Boolean(route.query.isMoreMenuOpen) && !displayStore.isDesktop" class="title">더보기</span>
			<span v-if="Boolean(route.query.isNotificationMenuOpen) && !displayStore.isDesktop" class="title">알림</span>
			<span v-if="Boolean(route.query.isInterestMenuOpen) && !displayStore.isDesktop" class="title">관심종목</span>
		</button>
		<div class="more_menu_quickMenu-mobile">
			<button v-if="tokenStore.isLogin" class="btn_toggle" aria-label="btn_toggle" @click.stop="onToggleNotification">
				<IconNotification
					:icon-color="Boolean(route.query.isNotificationMenuOpen) && !displayStore.isDesktop ? '#ff5e00' : '#fff'"
				/>
			</button>
			<button class="btn_toggle" aria-label="btn_toggle" @click="onClickHome">
				<IconHome />
			</button>
			<div v-if="!tokenStore.isLogin" class="btn_login" @click="router.push('/auth/login')">
				<button>로그인</button>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';

import IconHome from '@/components/atom/icon/IconHome.vue';
import IconNotification from '@/components/atom/icon/IconNotification.vue';
import { useDisplayStore } from '@/stores/display';
import { useTokenStore } from '@/stores/token';
import { closeMenuModal, openMenuModal } from '@/utils/function/modalMenu';

const router = useRouter();
const route = useRoute();
const displayStore = useDisplayStore();

const tokenStore = useTokenStore();

// -----function-----
// 더보기 버튼 클릭 시
const onClickResetHeaderMenu = () => {
	document.body.classList.remove('hidden');
	router.back();
};

// 홈 버튼 클릭 시
const onClickHome = () => {
	document.body.classList.remove('hidden');
	router.replace({ path: '/', query: {} });
};

// 알림 버튼 클릭 시
const onToggleNotification = () => {
	if (route.query.isNotificationMenuOpen) {
		closeMenuModal();
	} else {
		openMenuModal({ menu: `Notification` });
	}
};
</script>

<style lang="scss" scoped>
.more_menu_header-mobile {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: var(--space-xx-small);
	width: 100%;
	height: 6.4rem;
	font-size: var(--font-s-large);
	font-weight: var(--font-w-semi-bold);
	line-height: 2.7rem;
	padding: 1.85rem var(--space-large);
	box-shadow: 4px 4px 10px rgb(0, 0, 0, 0.4);
	.btn_back {
		display: flex;
		gap: 0.4rem;
		img {
			width: 2.6rem;
		}
	}
	.more_menu_quickMenu-mobile {
		display: flex;
		align-items: center;
		gap: var(--space-x-small);
		.btn_toggle {
			display: flex;
			gap: 0.05rem;
			img {
				width: 2.4rem;
			}
		}
		.btn_home {
			display: flex;
			img {
				width: 2.4rem;
			}
		}
		.btn_login {
			button {
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-light);
				line-height: 1.9rem;
				background-color: var(--color-primary);
				padding: 0.4rem 0.8rem;
				border-radius: 0.4rem;
			}
		}
	}
}
</style>
